/*
 * @Author: Q in
 * @Date: 2026-02-27 09:56:45
 * @LastEditors: Q in 
 * @LastEditTime: 2026-04-16 14:41:09
 * @FilePath: /bf_web/src/main.js
 * @Description: 入口文件
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { initTheme } from '@/utils/theme';

// 全局样式
import './style/index.scss';

// 引入element-ui
import ElementUI from 'element-ui';
import '@/style/theme/index.css';
// import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);

// 自定义主题样式
initTheme('theme2');

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
